import { Link } from "react-router-dom";

import type { ProductCatalog } from "../../lib/productCatalog";

export type ProductCatalogViewState = {
  catalog: ProductCatalog | null;
  catalogLoading?: boolean;
  catalogError?: unknown;
  retryCatalog?: () => void;
};

export function ProductCatalogContentUnavailable({
  loading = false,
  retry,
  plansHref = "/plans",
}: {
  loading?: boolean;
  retry?: () => void;
  plansHref?: string;
}) {
  return (
    <div
      role={loading ? "status" : "alert"}
      className="rounded-2xl border border-[#EADBC8] bg-white/80 px-5 py-5 text-sm leading-7 text-[#6B5851]"
    >
      <p>{loading ? "最新の料金・利用条件を確認しています。" : "最新の料金・利用条件を取得できませんでした。"}</p>
      {!loading ? (
        <div className="mt-3 flex flex-wrap gap-3">
          {retry ? (
            <button
              type="button"
              onClick={retry}
              className="font-black text-[#8A4F35] underline underline-offset-4"
            >
              再試行
            </button>
          ) : null}
          <Link to={plansHref} className="font-black text-[#8A4F35] underline underline-offset-4">
            料金ページで確認する
          </Link>
        </div>
      ) : null}
    </div>
  );
}
